/**
 * @voltxampere/ui — BME680 environmental sensor variant (Sprint 48-8, placeholder)
 *
 * Sprint 48-8 — New 4-in-1 environmental sensor: temperature, humidity,
 * pressure, gas (volatile organic compounds via heated metal-oxide
 * sensor). I2C 7-bit slave 0x77 (default; SDO pull-up → 0x76).
 * Bosch's high-end environmental sensor — used in indoor air quality
 * monitors, weather stations, smart agriculture.
 *
 * Sensor activation layer reads (subset MVP):
 *   - 0xD0 chip ID → constant 0x61
 *   - Pressure / temp registers similar to BMP280
 *   - 0x2A..0x2B gas resistance (VOC index)
 *
 * PLACEHOLDER — full Bosch BSEC library + IAQ index calculation
 * Sprint 50+.
 *
 * Reference: Bosch BME680 datasheet (BST-BME680-DS001-2, 2017).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorBme680 = {
    id: "bme680",
    nameTr: "BME680 (4-in-1 Çevre Sensörü, I2C, placeholder)",
    nameEn: "BME680 (4-in-1 Environmental Sensor, I2C, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "BME680",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 3.3,
        i2cAddress: 0x77,
        i2cFrequency: 400_000,
        chipIdRegister: 0xd0,
        chipIdValue: 0x61,
        measuresTemperature: true,
        measuresHumidity: true,
        measuresPressure: true,
        measuresGasVoc: true,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-bme680.js.map